import React, { useState } from "react";
import Canvas from "./Canvas";
// import { connect } from "react-redux";
// import Spinner from "../utilities/Spinner";
import Alert from "../utilities/Alert";
// import { clearImageData } from "../../actions/imageActions";
import "../../assets/css/drawcharts.css";

const DrawCharts = () => {
  const [showAlert, setShowAlert] = useState({
    show: false,
    message: "",
    type: null,
  });
  const displayAlert = (message, type = "danger") => {
    setShowAlert({
      show: true,
      message,
      type,
    });
    setTimeout(() => {
      setShowAlert({
        show: false,
        message: "",
        type,
      });
    }, 5000);
  };

  return (
    <React.Fragment>
      {showAlert.show ? (
        <Alert message={showAlert.message} type={showAlert.type} />
      ) : null}
      <Canvas displayAlert={displayAlert} />
    </React.Fragment>
  );
};

export default DrawCharts;
